<script>
import DownloadForm from '@views/downloads/form';

export default {
  components: {
    DownloadForm,
  },
  props: {
    value: {
      type: Boolean,
      default: null,
    },
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
    initialCategory: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    value(val) {
      this.showModal = !!val;
    },
  },
  methods: {
    submit() {
      this.$emit('submitted');
    },
  },
};
</script>

<template>
  <b-modal
    v-model="showModal"
    size="lg"
    hide-footer
    :title="loadedId ? $t('titles.edit_download') : $t('titles.create_download')"
    static
    @hidden="$emit('hidden')"
  >
    <DownloadForm
      v-if="showModal"
      :loaded-id="loadedId"
      :initial-category="initialCategory"
      @submitted="submit"
    />
  </b-modal>
</template>
